import BaseClass from "./BaseClass";

const defaultOptions = {};

export default class Auth extends BaseClass {
    constructor(options)
    {
        super(options, defaultOptions);

        this.init();
    }

    init()
    {
        $(document).ready(function () {
            // register
            $("#register-form").on("submit", function (e) {
                e.preventDefault();
                Auth.checkPassword("register");
            });

            // login
            $("#login-form").on("submit", function (e) {
                e.preventDefault();
                Auth.checkPasswordLogin();
            });

            // forgot-password
            $("#password-form").on("submit", function (e) {
                e.preventDefault();
                Auth.checkEmail();
            });

            // new-password
            $("#new-password-form").on("submit", function (e) {
                e.preventDefault();
                Auth.checkPassword("new-forgot");
            });

            // reservation-check
            $("#reservation-check-form").on("submit", function (e) {
                e.preventDefault();

                Auth.checkReservation();
            });

            $("[data-submitResendConfirmation]").on('click', () => {
                Auth.submitResendConfirmation();
            })

            $("[data-anyProblems]").on('click', () => {
                $('[data-hideonanyproblems]').hide();
                $("[data-anyProblems]").hide();
                $("[data-forgotSecond]").hide();
                $("[data-btnForgotSecond]").hide();
                $("[data-btnForgotFirst]").hide();

                $("[data-forgotCustomer]").show();
                $("[data-btnForgotCustomer]").show();
            });

            $("[data-back]").on('click', () => {
                $('[data-hideonanyproblems]').show();
                $("[data-btnForgotFirst]").show();
                $("[data-anyProblems]").show();

                $("[data-forgotCustomer]").hide();
                $("[data-btnForgotCustomer]").hide();
            });

            $("[data-didntFindConfirmation]").on('click', () => {
                $("[data-didntFindConfirmation]").hide();
                $(".reservation-pin").hide();
                $("input[name='reservation']").hide();
                $("[data-reservationError]").hide();
                $("[data-reservationErrorImg]").hide();
                $("[data-reservationOkImg]").hide();
                $("[data-btnReservationFirst]").hide();
                $("[data-emailConfSuccess]").hide();

                $("[data-didntFind]").show();
                $("[data-backReservation]").show();
                $("[data-didntFindInput]").show();
                $("[data-submitResendConfirmation]").show();
                $("[data-didntFindBtn]").show();
            });

            $("[data-anyHelpText]").on('click', () => {
                $("[data-didntFind]").hide();
                $("[data-didntFindBtn]").hide();
                $("[data-confSuccessBack]").hide();

                $("[data-anyHelpBtn]").show();
                $("[data-anyHelp]").show();
            })

            $("[data-backReservation]").on('click', () => {
                $("[data-didntFindConfirmation]").show();
                $(".reservation-pin").show();
                $("[data-btnReservationFirst]").show();
                $("input[name='reservation']").show();

                $("[data-anyHelp]").hide();
                $("[data-anyHelpBtn]").hide();
                $("[data-didntFind]").hide();
                $("[data-didntFindBtn]").hide();
            });

            $("[data-anyProblemsRegistration]").on('click', () => {
                $("[data-anyProblemsHide]").hide();
                $("[data-anyProblemsShow]").show();
            });

            $("[data-doneConf]").on('click', () => {
                $("[data-didntFindConfirmation]").show();
                $(".reservation-pin").show();
                $("[data-btnReservationFirst]").show();
                $("input[name='reservation']").show();

                $("[data-anyHelp]").hide();
                $("[data-anyHelpBtn]").hide();
                $("[data-didntFind]").hide();
                $("[data-didntFindBtn]").hide();
                $("[data-confSuccessBack]").hide();
            })

            $("[data-confSuccessBack]").on('click', () => {
                $("[data-confSuccessBack]").hide();
                $("[data-didntFindConfirmation]").hide();
                $("[data-emailConfSuccess]").hide();
                $("[data-anyHelp]").hide();
                $("[data-anyHelpBtn]").hide();

                $("[data-didntFind]").show();
                $("[data-backReservation]").show();
                $("[data-didntFindInput]").show();
                $("[data-submitResendConfirmation]").show();
                $("[data-didntFindBtn]").show();
            });
        });
    }

  /**
   * Function that checks email correctness in auth forgot password
   * It is not called in login check because we can login by username
   */
    static checkEmail()
    {
        let emailInput = $("input[name='email']");
        let recaptchaInput = $('#recaptcha-token');
        let parentWrapperEmail = $(emailInput).parents("[data-authWrapper]");
        let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        let locale = $('meta[name="country"]').attr("content");
        let emailCorrectForgot = true;

        if (!regex.test($(emailInput).val())) {
            $(parentWrapperEmail).addClass("error");
            $(emailInput).addClass("error");
            $("[data-emailError]").css("display", "block");
            $("[data-emailErrorImg]").css("display", "block");
            $("[data-emailOkImg]").css("display", "none");
            $("[data-recaptchaError]").css("display", "none");
            emailCorrectForgot = false;
        }

        if (emailCorrectForgot) {
            $.ajax({
                headers: {
                    "X-App-Locale": locale,
                },
                url: window.location.origin + "/user/forgot/check-email",
                type: "POST",
                data: {
                    email: $(emailInput).val(),
                    captcha: recaptchaInput.val(),
                    _token: $('meta[name="csrf-token"]').attr("content"),
                },
                success: function (data) {
                    let parsedData = JSON.parse(data);

                    if (!parsedData["errorEmail"] && !parsedData["captchaError"]) {
                        $(emailInput).css("display", "none");

                        $("[data-emailError]").css("display", "none");
                        $("[data-emailExistence]").css("display", "none");
                        $("[data-emailErrorImg]").css("display", "none");
                        $("[data-emailOkImg]").css("display", "none");
                        $("[data-recaptchaError]").css("display", "none");

                        let translationOne = $(
                            "input[name='forgot_second_text_one']"
                        ).val();
                        let translationTwo = $(
                            "input[name='forgot_second_text_two']"
                        ).val();
                        let emailWithCss =
                            "<span class='light-blue weight-medium'>" + $(emailInput).val() + "</span>";

                        let finalString =
                        translationOne + " " + emailWithCss + ". " + translationTwo;
                        $("[data-forgotSecond]").css("display", "block");
                        $("[data-forgotSecond] p").html(finalString);
                        $("[data-btnForgotSecond]").css("display", "block");
                        $("[data-btnForgotFirst]").css("display", "none");
                    } else {
                        if (parsedData["errorEmail"]) {
                            $(emailInput).addClass("error");
                            $("[data-emailError]").css("display", "none");
                            $("[data-emailExistence]").css("display", "block");
                            $("[data-emailErrorImg]").css("display", "block");
                            $("[data-emailOkImg]").css("display", "none");
                            $("[data-recaptchaError]").css("display", "none");
                        } else if (parsedData["captchaError"]) {
                            $(emailInput).addClass("error");
                            $("[data-emailError]").css("display", "none");
                            $("[data-emailExistence]").css("display", "none");
                            $("[data-emailErrorImg]").css("display", "none");
                            $("[data-recaptchaError]").css("display", "block");
                            $("[data-emailOkImg]").css("display", "none");
                        }
                    }
                },
                error: function () {
                    window.recaptcha((token) => {
                        $('#recaptcha-token').val(token);
                    });
                }
            });
        }
    }

  /**
   * Function that checks if passwords match and if the length is correct
   *
   * @param {String} event register or new-forgot
   */
    static checkPassword(event)
    {
        let pass = $("input[name='new_password']");
        let passRetype = $("input[name='new_password_retype']");
        let userID = $("input[name='userID']");

        if (event === "register") {
            Auth.checkDataRegister(pass, passRetype);
        } else {
            Auth.checkPasswordNew(pass, passRetype, userID);
        }
    }

  /**
   * Function that checks passwords in new-password form
   *
   * @param {Element} password new password input
   * @param {Element} passwordRetype new password retyped input
   * @param {Element} UserID is ID of user
   */
    static checkPasswordNew(password, passwordRetype, userID)
    {
        let locale = $('meta[name="country"]').attr("content");
        let timezoneOffsetMinutes = new Date().getTimezoneOffset();
        timezoneOffsetMinutes = timezoneOffsetMinutes == 0 ? 0 : -timezoneOffsetMinutes;

        let browser = window.navigator.appVersion.includes('Chrome') ? 'Chrome' : window.navigator.appVersion.includes('Safari') ? 'Safari' : window.navigator.appVersion.includes('Opera') ? 'Opera' : 'Mozilla';
        let platform = window.navigator.platform;
        let isMobile = false;

        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            isMobile = true;
        }

        $.ajax({
            headers: {
                "X-App-Locale": locale,
            },
            url: window.location.origin + "/user/new-password/check-password",
            type: "POST",
            data: {
                password: $(password).val(),
                password_confirm: $(passwordRetype).val(),
                user_id: $(userID).val(),
                timezoneOffsetMinutes: timezoneOffsetMinutes,
                browser: browser,
                isMobile: isMobile,
                platform: platform,
                _token: $('meta[name="csrf-token"]').attr("content"),
            },
            success: function (data) {
                let parsedData = JSON.parse(data);
                let parentWrapperPass = $(password).parents("[data-authWrapper]");
                let parentWrapperPassRetype = $(passwordRetype).parents(
                    "[data-authWrapper]"
                );

                Auth.showHidePasswordErrors(
                    parsedData,
                    password,
                    parentWrapperPass,
                    passwordRetype,
                    parentWrapperPassRetype
                );

                // if everything is ok
                if (
                !parsedData["passwordError"] &&
                !parsedData["passwordRetypeError"]
                ) {
                    window.location.href = parsedData["url"];
                }
            }
        });
    }

  /**
   * Function that handles element errors showing/hiding
   *
   * @param {Json} parsedData data from ajax call
   * @param {Element} password password input
   * @param {Element} parentWrapperPass password input wrapper
   * @param {Element} passwordRetype password retype input
   * @param {Element} parentWrapperPassRetype password retype input wrapper
   * @param {Element} emailInput email input
   * @param {Element} parentWrapperEmail email input wrapper
   */
    static showHidePasswordErrors(
        parsedData,
        password,
        parentWrapperPass,
        passwordRetype,
        parentWrapperPassRetype,
        emailInput = null,
        parentWrapperEmail = null
    ) {
        // if email already exists
        if (parsedData["emailExists"]) {
            $(emailInput).addClass("error");
            $(parentWrapperEmail).addClass("error");
            $("[data-emailExistence]").css("display", "block");
            $("[data-emailErrorImg]").css("display", "block");
            $("[data-emailOkImg]").css("display", "none");
        } else {
            $(emailInput).removeClass("error");
            $(parentWrapperEmail).removeClass("error");
            $("[data-emailExistence]").css("display", "none");
            $("[data-emailError]").css("display", "none");
            $("[data-emailErrorImg]").css("display", "none");
            $("[data-emailOkImg]").css("display", "block");
        }

        // if password is not in correct format
        if (parsedData["passwordError"]) {
            $(password).addClass("error");
            $(parentWrapperPass).addClass("error");
            $("[data-passwordErrorLength]").css("display", "block");
            $("[data-passwordErrorLengthImg]").css("display", "block");

            $(passwordRetype).addClass("error");
            $(parentWrapperPassRetype).addClass("error");
            $("[data-passwordErrorMismatchImg]").css("display", "block");
        } else {
            $(password).removeClass("error");
            $(parentWrapperPass).removeClass("error");
            $("[data-passwordErrorLength]").css("display", "none");
            $("[data-passwordErrorLengthImg]").css("display", "none");
        }

        // if passwords do not match
        if (parsedData["passwordRetypeError"]) {
            $(passwordRetype).addClass("error");
            $(parentWrapperPassRetype).addClass("error");
            $("[data-passwordErrorMismatchImg]").css("display", "block");
            $("[data-passwordErrorMismatch]").css("display", "block");
        } else {
            $("[data-passwordErrorMismatch]").css("display", "none");

            if (!parsedData["passwordError"]) {
                $(passwordRetype).removeClass("error");
                $(parentWrapperPassRetype).removeClass("error");
                $("[data-passwordErrorMismatchImg]").css("display", "none");
            }
        }
    }

  /**
   * Function that checks if email has correct form and if it already exists
   *
   * @param {Element} password element with new password
   * @param {Element} passwordRetype element with retyped password
   */
    static checkDataRegister(password, passwordRetype)
    {
        let emailInput = $("input[name='email']");
        let recaptchaInput = $('#recaptcha-token');
        let parentWrapperEmail = $(emailInput).parents("[data-authWrapper]");
        let parentWrapperPass = $(password).parents("[data-authWrapper]");
        let parentWrapperPassRetype = $(passwordRetype).parents(
            "[data-authWrapper]"
        );
        let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        let locale = $('meta[name="country"]').attr("content");
        let error = this.checkFirstLastName();

        if (!regex.test($(emailInput).val())) {
            $(parentWrapperEmail).addClass("error");
            $(emailInput).addClass("error");
            $("[data-emailError]").css("display", "block");
            $("[data-emailErrorImg]").css("display", "block");
            $("[data-emailOkImg]").css("display", "none");
            error = true;
        } else {
            $(parentWrapperEmail).removeClass("error");
            $(emailInput).removeClass("error");
            $("[data-emailError]").css("display", "none");
            $("[data-emailErrorImg]").css("display", "none");
        }

        if (!error) {
            let firstName = $("input[name='first_name']").val();
            let lastName = $("input[name='last_name']").val();

            $.ajax({
                headers: {
                    "X-App-Locale": locale,
                },
                url: window.location.origin + "/user/register/check-data",
                type: "POST",
                data: {
                    captcha: recaptchaInput.val(),
                    email: $(emailInput).val(),
                    password: $(password).val(),
                    password_confirm: $(passwordRetype).val(),
                    first_name: firstName,
                    last_name: lastName,
                    _token: $('meta[name="csrf-token"]').attr("content"),
                },
                success: function (data) {
                    let parsedData = JSON.parse(data);
                    Auth.showHidePasswordErrors(
                        parsedData,
                        password,
                        parentWrapperPass,
                        passwordRetype,
                        parentWrapperPassRetype,
                        emailInput,
                        parentWrapperEmail
                    );

                    if (parsedData["captchaError"]) {
                        $("[data-recaptchaError]").css("display", "block");
                        return;
                    } else {
                        $("[data-recaptchaError]").css("display", "none");
                    }

                    // if everything is ok
                    if (
                    !parsedData["passwordError"] &&
                    !parsedData["emailExists"] &&
                    !parsedData["passwordRetypeError"]
                    ) {
                        $("[data-emailOkImg]").css("display", "block");
                        $("[data-hideaftersuccess]").hide();
                        $("[data-showaftersuccess]").show();

                        let translationOne = $("input[name='email_text_one']").val();
                        let translationTwo = $("input[name='email_text_two']").val();
                        let emailWithCss = "<span class='light-blue weight-medium'>" + $(emailInput).val() + "</span>";

                        let finalString = translationOne + " " + emailWithCss + ". " + translationTwo;
                        $("[data-emailconfirmationtext]").html(finalString);
                    }

                    window.recaptcha((token) => {
                        $('#recaptcha-token').val(token);
                    });
                }
            });
        }
    }

  /**
   * Function that checks password in login
   */
    static checkPasswordLogin()
    {
        let pass = $("input[name='new_password']");
        let locale = $('meta[name="country"]').attr("content");
        let parentWrapperPass = $(pass).parents("[data-authWrapper]");
        let emailUsernameInput = $("input[name='email_or_username']");
        let recaptchaInput = $('#recaptcha-token');
        let parentWrapperEmail = $(emailUsernameInput).parents(
            "[data-authWrapper]"
        );
        let favHotel = $("input[name='fav_hotel']").val();
        let reloadAfterFav = $("input[name='reload_fav_hotel']").val();
        let likeReview = $("input[name='like_review']").val();
        let reservation = $("input[name='is_reservation']").val();

        if ($(emailUsernameInput).val() !== "") {
            $.ajax({
                headers: {
                    "X-App-Locale": locale,
                },
                url: window.location.origin + "/user/login/check-password",
                type: "POST",
                data: {
                    password: $(pass).val(),
                    emailOrUsername: $(emailUsernameInput).val(),
                    favHotel: favHotel,
                    likeReview: likeReview,
                    reservation: reservation,
                    reloadAfterFav: reloadAfterFav,
                    captcha: recaptchaInput.val(),
                    _token: $('meta[name="csrf-token"]').attr("content"),
                },
                success: function (data) {
                    let parsedData = JSON.parse(data);
                    // handle different errors
                    if (parsedData["captchaError"]) {
                        $(emailUsernameInput).removeClass("error");
                        $(parentWrapperEmail).removeClass("error");
                        $("[data-recaptchaError]").css("display", "block");
                        $("[data-emailNotVerifiedError]").css("display", "none");
                        $("[data-emailExistence]").css("display", "none");
                        $("[data-userNotActiveError]").css("display", "none");
                        $("[data-emailErrorImg]").css("display", "none");
                        $("[data-emailOkImg]").css("display", "none");
                    } else if (parsedData["emailUsernameError"]) {
                        $(emailUsernameInput).addClass("error");
                        $(parentWrapperEmail).addClass("error");
                        $("[data-recaptchaError]").css("display", "none");
                        $("[data-emailNotVerifiedError]").css("display", "none");
                        $("[data-emailExistence]").css("display", "block");
                        $("[data-userNotActiveError]").css("display", "none");
                        $("[data-emailErrorImg]").css("display", "block");
                        $("[data-emailOkImg]").css("display", "none");
                    } else if (parsedData["emailNotVerifiedError"]) {
                        $(emailUsernameInput).addClass("error");
                        $(parentWrapperEmail).addClass("error");
                        $("[data-recaptchaError]").css("display", "none");
                        $("[data-emailExistence]").css("display", "none");
                        $("[data-userNotActiveError]").css("display", "none");
                        $("[data-emailNotVerifiedError]").css("display", "block");
                        $("[data-emailErrorImg]").css("display", "block");
                        $("[data-emailOkImg]").css("display", "none");
                    } else if (parsedData["authenticationError"]) {
                        $(emailUsernameInput).removeClass("error");
                        $(parentWrapperEmail).removeClass("error");
                        $(pass).addClass("error");
                        $(parentWrapperPass).addClass("error");
                        $("[data-recaptchaError]").css("display", "none");
                        $("[data-emailNotVerifiedError]").css("display", "none");
                        $("[data-emailErrorImg]").css("display", "none");
                        $("[data-userNotActiveError]").css("display", "none");
                        $("[data-emailExistence]").css("display", "none");
                        $("[data-emailOkImg]").css("display", "block");
                        $("[data-passwordErrorImg]").css("display", "block");
                        $("[data-passwordIncorrect]").css("display", "block");
                    } else if (parsedData["userNotActive"]) {
                        $(emailUsernameInput).addClass("error");
                        $(parentWrapperEmail).addClass("error");
                        $("[data-recaptchaError]").css("display", "none");
                        $("[data-emailExistence]").css("display", "none");
                        $("[data-emailNotVerifiedError]").css("display", "none");
                        $("[data-userNotActiveError]").css("display", "block");
                        $("[data-emailErrorImg]").css("display", "block");
                        $("[data-emailOkImg]").css("display", "none");
                    } else if (parsedData["noError"] || parsedData["toURL"] || parsedData["reload"]) {
                        $(emailUsernameInput).removeClass("error");
                        $(pass).removeClass("error");
                        $(parentWrapperPass).removeClass("error");
                        $(parentWrapperEmail).removeClass("error");
                        $("[data-recaptchaError]").css("display", "none");
                        $("[data-emailNotVerifiedError]").css("display", "none");
                        $("[data-userNotActiveError]").css("display", "none");
                        $("[data-emailExistence]").css("display", "none");
                        $("[data-emailErrorImg]").css("display", "none");
                        $("[data-passwordErrorImg]").css("display", "none");
                        $("[data-passwordIncorrect]").css("display", "none");
                        $("[data-emailOkImg]").css("display", "block");

                        if (parsedData["reload"]) {
                            window.location.reload();
                        } else {
                            window.location.href = parsedData["toURL"];
                        }
                    }

                    window.recaptcha((token) => {
                        $('#recaptcha-token').val(token);
                    });
                }
            });
        } else {
            $(emailUsernameInput).addClass("error");
            $(parentWrapperEmail).addClass("error");
            $("[data-emailExistence]").css("display", "block");
            $("[data-emailErrorImg]").css("display", "block");
        }
    }

  /**
   * Function that checks if reservation with pin exists
   */
    static checkReservation()
    {
        let locale = $('meta[name="country"]').attr("content");
        let captchaInput = $('#recaptcha-token');
        let reservationNumberInput = $("input[name='reservation']");
        let reservationPinInput = $("input[name='pin']");

        let parentWrapperNumber = $(reservationNumberInput).parents(
            "[data-authWrapper]"
        );
        let parentWrapperPin = $(reservationPinInput).parents("[data-authWrapper]");
        $("[data-recaptchaError]").css("display", "none");

        $.ajax({
            headers: {
                "X-App-Locale": locale,
            },
            url: window.location.origin + "/user/reservation-check",
            type: "POST",
            data: {
                reservationNumber: $(reservationNumberInput).val(),
                reservationPin: $(reservationPinInput).val(),
                captcha: captchaInput.val(),
                _token: $('meta[name="csrf-token"]').attr("content"),
            },
            success: function (data) {
                let parsedData = JSON.parse(data);

                if (parsedData["noError"]) {
                    $(reservationNumberInput).removeClass("error");
                    $(parentWrapperNumber).removeClass("error");
                    $(parentWrapperPin).removeClass("error");
                    $(reservationPinInput).removeClass("error");
                    $("[data-reservationError]").css("display", "none");
                    $("[data-reservationErrorImg]").css("display", "none");
                    $("[data-pinError]").css("display", "none");
                    $("[data-pinErrorImg]").css("display", "none");
                    $("[data-reservationOkImg]").css("display", "block");
                    window.location.href = parsedData["url"];
                }

                if (parsedData["pinError"]) {
                    $(parentWrapperPin).addClass("error");
                    $(reservationPinInput).addClass("error");
                    $("[data-pinErrorImg]").css("display", "block");
                    $("[data-pinError]").css("display", "block");
                } else {
                    $(parentWrapperPin).removeClass("error");
                    $(reservationPinInput).removeClass("error");
                    $("[data-pinError]").css("display", "none");
                    $("[data-pinErrorImg]").css("display", "none");
                }

                if (parsedData["resError"]) {
                    $(parentWrapperNumber).addClass("error");
                    $(reservationNumberInput).addClass("error");
                    $("[data-reservationOkImg]").css("display", "none");
                    $("[data-reservationErrorImg]").css("display", "block");
                    $("[data-reservationError]").css("display", "block");
                } else {
                    $(reservationNumberInput).removeClass("error");
                    $(parentWrapperNumber).removeClass("error");
                    $("[data-reservationError]").css("display", "none");
                    $("[data-reservationErrorImg]").css("display", "none");
                    $("[data-reservationOkImg]").css("display", "block");
                }

                if (parsedData["captchaError"]) {
                    $("[data-recaptchaError]").css("display", "block");
                }

                window.recaptcha((token) => {
                    $('#recaptcha-token').val(token);
                });
            }
        });

        window.recaptcha((token) => {
            $('#recaptcha-token').val(token);
        });
    }

  /**
   * Function that checks if first/last name is empty when registering
   *
   * @returns {boolean}
   */
    static checkFirstLastName()
    {
        let firstNameInput = $("input[name='first_name']");
        let lastNameInput = $("input[name='last_name']");
        let firstNameInputWrapper = $(firstNameInput).parents("[data-authWrapper]");
        let lastNameInputWrapper = $(lastNameInput).parents("[data-authWrapper]");
        let error = false;

        if (
        $(firstNameInput).val() === "" ||
        !$(firstNameInput)
        .val()
        .replace(/\s/g, "").length
        ) {
            $(firstNameInputWrapper).addClass("error");
            $(firstNameInput).addClass("error");
            $("[data-firstNameError]").css("display", "block");
            error = true;
        } else {
            $(firstNameInputWrapper).removeClass("error");
            $(firstNameInput).removeClass("error");
            $("[data-firstNameError]").css("display", "none");
        }

        if (
        $(lastNameInput).val() === "" ||
        !$(lastNameInput)
        .val()
        .replace(/\s/g, "").length
        ) {
            $(lastNameInputWrapper).addClass("error");
            $(lastNameInput).addClass("error");
            $("[data-lastNameError]").css("display", "block");
            error = true;
        } else {
            $(lastNameInputWrapper).removeClass("error");
            $(lastNameInput).removeClass("error");
            $("[data-lastNameError]").css("display", "none");
        }

        return error;
    }

    /**
     * Function that checks email correctness and sends email with newest reservation or shows msg that user does not have reservations
     *
     * @returns void
     */
    static submitResendConfirmation()
    {
        let emailInput = $("input[name='conf_email']");
        let captchaInput = $('#recaptcha-token');
        let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        let parentWrapperEmail = $(emailInput).parents("[data-authWrapper]");
        let locale = $('meta[name="country"]').attr("content");

        if (!regex.test($(emailInput).val())) {
            $(parentWrapperEmail).addClass("error");
            $(emailInput).addClass("error");
            $("[data-emailError]").show();
            $("[data-emailConfErrorImg]").show();
            $("[data-emailConfOk]").hide();
            $("[data-recaptchaError]").css("display", "none");
            return;
        } else {
            $("[data-emailConfOk]").show();
            $("[data-emailError]").hide();
            $("[data-emailConfErrorImg]").hide();
            $("[data-emailConfError]").hide();
            $(parentWrapperEmail).removeClass("error");
            $(emailInput).removeClass("error");
            $("[data-recaptchaError]").css("display", "none");
        }

        $.ajax({
            headers: {
                "X-App-Locale": locale,
            },
            url: window.location.origin + "/user/resend-email",
            type: "POST",
            data: {
                email: $(emailInput).val(),
                captcha: captchaInput.val(),
                _token: $('meta[name="csrf-token"]').attr("content"),
            },
            success: function (data) {
                let parsedData = JSON.parse(data);

                if (parsedData["emailError"]) {
                    $(parentWrapperEmail).addClass("error");
                    $(emailInput).addClass("error");
                    $("[data-emailConfError]").show();
                    $("[data-emailConfOk]").hide();
                    $("[data-emailConfErrorImg]").show();
                    $("[data-recaptchaError]").css("display", "none");
                } else if(parsedData["captchaError"]) {
                    $(parentWrapperEmail).removeClass("error");
                    $(emailInput).removeClass("error");
                    $("[data-emailConfError]").hide();
                    $("[data-emailConfOk]").hide();
                    $("[data-emailConfErrorImg]").hide();
                    $("[data-recaptchaError]").css("display", "block");
                } else {
                    $(emailInput).hide();
                    $("[data-submitResendConfirmation]").hide();
                    $("[data-hideOnSubmit]").hide();
                    $("[data-emailConfSuccess]").show();
                    $("[data-backReservationSecond]").hide();
                    $("[data-confSuccessBack]").show();
                    $("[data-emailConfOk]").hide();
                    $("[data-recaptchaError]").css("display", "none");

                    let translationOne = $("input[name='email_text_one']").val();
                    let translationTwo = $("input[name='email_text_two']").val();
                    let emailWithCss = "<span class='light-blue weight-medium'>" + $(emailInput).val() + "</span>";
                    let finalString = translationOne + " " + emailWithCss + ". " + translationTwo;
                    $("[data-emailConfirmationText]").html(finalString);

                    $(emailInput).val("");
                }

                window.recaptcha((token) => {
                    $('#recaptcha-token').val(token);
                });
            }
        });

        window.recaptcha((token) => {
            $('#recaptcha-token').val(token);
        });
    }

    recaptcha(callBack, repeateRefresh = false)
    {
        grecaptcha.execute(window.recaptchaKey, {action: 'submit'}).then(callBack);

        if (repeateRefresh) {
            setTimeout(() => {
                recaptcha(callBack, repeateRefresh);
            }, 60000);
        }
    }
}
